import { TableCell, TableHead, TableRow } from '@mui/material'
import React from 'react'
import useStyles from "../../styles/navbar/TableHeadStyles";
import { useTranslation } from 'react-i18next';
function TableHeader() {
    const classes = useStyles();
    const {t} = useTranslation();
  return (
    <TableHead >
        <TableRow className={classes.tableHead}>
                <TableCell>{t("lp")}</TableCell>
                <TableCell>{t("product")}</TableCell>
                <TableCell>{t("recipient")}</TableCell>
                <TableCell>{t("quantity")}</TableCell>
                <TableCell>{t("Nr BE")}</TableCell>
                <TableCell>{t("date")}</TableCell>
        </TableRow>
    </TableHead>
  )
}

export default TableHeader;